import { baseApi } from "./baseApi";

const TRANSSHIPMENT_BASE_URL = "/transshipments"

export const transshipmentApi = baseApi.injectEndpoints({
    tagTypes: ["Transshipment"],

    endpoints: (builder) => ({
        addTransshipment: builder.mutation({
            query: (payLoad) => ({
                url: TRANSSHIPMENT_BASE_URL,
                method: "POST",
                body: payLoad
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "Transshipment", id: _id },
                { type: "Transshipment", id: "LIST" },
            ],
        }),

        listTransshipment: builder.query({
            query: (params) => ({
                url: TRANSSHIPMENT_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Transshipment", _id })),
                        { type: "Transshipment", id: "LIST" },
                    ]
                    : [{ type: "Transshipment", id: "LIST" }],
        }),

        getDDLTransshipmentList: builder.query({
            query: (params) => ({ url: `${TRANSSHIPMENT_BASE_URL}/ddl`, params }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Transshipment", _id })),
                        { type: "Transshipment", id: "DDL" },
                    ]
                    : [{ type: "Transshipment", id: "DDL" }],
        }),

        getTransshipmentDetail: builder.query({
            query: (transhipId) => `${TRANSSHIPMENT_BASE_URL}/${transhipId}`,
            providesTags: (_result, _error, { _id }) => [
                { type: "Transshipment", _id },
                { type: "Transshipment", id: "LIST" },
            ],
        }),

        updateTransshipment: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${TRANSSHIPMENT_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "Transshipment", id },
                { type: "Transshipment", id: "LIST" },
            ],
        }),
    }),
})

export const {
    useAddTransshipmentMutation,
    useListTransshipmentQuery,
    useLazyListTransshipmentQuery,
    useLazyGetDDLTransshipmentListQuery,
    useGetTransshipmentQuery,
    useGetTransshipmentDetailQuery,
    useUpdateTransshipmentMutation,
} = transshipmentApi;